import { filter, sortBy, map } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsKPILoaded, selectShouldScrollToSelection } from '../selectors';
import { getTranslatedHistoScatterV2KPIName, getTranslatedKPIName, getTranslatedKPINameV2 } from 'helpers/translateHelper';
import { opButtons } from '../../ChartView/constants';


const translateAndSortKPIs = (kpis) => {
    return sortBy(map(kpis, (kpi) => {
        return {
            ...kpi,
            displayName: getTranslatedKPIName(kpi)
        };
    }), (kpi) => kpi?.displayName?.toLowerCase());
};

const translateAndSortV2KPIs = (kpis) => {
    return sortBy(map(kpis, (kpi) => {
        return {
            ...kpi,
            name: getTranslatedHistoScatterV2KPIName(kpi)
        };
    }), (kpi) => kpi?.name?.toLowerCase());
};

const translateAndSortTrendKPIs = (kpis) => {
    return sortBy(map(kpis, (kpi) => {
        return {
            ...kpi,
            displayName: getTranslatedKPINameV2(kpi)
        };
    }), (kpi) => kpi?.displayName?.toLowerCase());
};

// eslint-disable-next-line import/no-unused-modules
export const getKPIListForAsset = (kpiList, _, componentID, activeTab, selectedKPIType) => {
    if (selectedKPIType === 1) {
        const newKpiList = map(kpiList?.kpis, (kpi) => {
            return {
                ...kpi,
                componentID
            };
        });
        const parameterKPIList = translateAndSortTrendKPIs(filter(newKpiList, (kpi) => {
            return kpi && kpi.appendCodeToTranslation === true;
        }));
        const standardKPIList = translateAndSortTrendKPIs(filter(newKpiList, (kpi) => {
            return kpi && kpi.appendCodeToTranslation === false;
        }));
        return {
            kpis:
            {
                parameterKPIList,
                standardKPIList
            },
            loadingStatus: kpiList?.loadingStatus
        };
    } else {
        const parameterKPIList = [opButtons.histogramV2, opButtons.scatterPlotV2].includes(activeTab)
            ? translateAndSortV2KPIs(filter(kpiList?.kpis, (kpi) => {
                return kpi && kpi.allSignal === true;
            }))
            : translateAndSortKPIs(filter(kpiList?.kpis, (kpi) => {
                return kpi && kpi.allSignal === true;
            }));

        const standardKPIList = [opButtons.histogramV2, opButtons.scatterPlotV2].includes(activeTab)
            ? translateAndSortV2KPIs(filter(kpiList?.kpis, (kpi) => {
                return kpi && !kpi.allSignal;
            }))
            : translateAndSortKPIs(filter(kpiList?.kpis, (kpi) => {
                return kpi && kpi.allSignal === false;
            }));
        return {
            kpis:
            {
                parameterKPIList,
                standardKPIList
            },
            loadingStatus: kpiList?.loadingStatus
        };
    }
};

// eslint-disable-next-line import/no-unused-modules
export const useKPILoadingTrigger = () => {
    const [scrollTriggered, setScrollTriggered] = useState(false);
    const isKpiLoaded = useSelector((state) => selectIsKPILoaded(state));
    const shouldScrollToSelection = useSelector((state) => selectShouldScrollToSelection(state));

    useEffect(() => {
        if (!scrollTriggered && isKpiLoaded && shouldScrollToSelection) {
            setScrollTriggered(true);
        }
    }, [isKpiLoaded]);

    return scrollTriggered;
};


// eslint-disable-next-line import/no-unused-modules
export const isKpiSelected = (chartData, kpi) => {
    if (chartData?.filter((selectedKPI) => selectedKPI?.kpi?.componentID === kpi?.componentID && selectedKPI?.kpi.measurementTypeKey === kpi?.measurementTypeKey)?.length > 0) {
        return true;
    }
    return false;
};
// eslint-disable-next-line import/no-unused-modules
export const isKpiSelectedTrend = (chartData, kpi) => {
    return chartData?.filter((selectedKPI) => selectedKPI?.kpi?.componentID?.toString() === kpi?.componentID?.toString() && selectedKPI?.kpi?.timeseriesKey?.toLowerCase() === kpi?.timeseriesKey?.toLowerCase())?.length > 0;
};
// eslint-disable-next-line import/no-unused-modules
export const isKpiSelectedV2 = (chartData, kpi, isFromScatter) => {
    return chartData?.filter((selectedKPI) => selectedKPI?.kpi?.assetId?.toString() === kpi?.assetId?.toString() && (isFromScatter ? selectedKPI?.kpi.scatterKey === kpi?.scatterKey : selectedKPI?.kpi.histogramKey === kpi?.histogramKey))?.length > 0;
};
